<template>
  <div class="statistics_channel">
    <!-- 面包屑 -->
    <el-form v-model="queryData">
      <el-row>
        <el-date-picker
          v-model="date"
          style="width: 380px; margin-left: 10px"
          :fit="true"
          type="daterange"
          value-format="yyyy-MM-dd"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        />
        <el-input
          v-model.trim="queryData.linkName"
          style="width: 200px; margin: 0 0 0 10px"
          placeholder="客服名称"
          clearable
          @clear="clear"
        />
        <el-button
          type="primary"
          class="search"
          style="margin: 0 0 0 10px"
          @click="search"
        >搜索</el-button>
      </el-row>
    </el-form>
    <!-- table -->

    <el-table
      class="table"
      :data="tableData"
      :header-cell-style="{'text-align':'center'}"
      :cell-style="{'text-align':'center'}"
      style="width: 98.5%; margin-top: 30px; margin-left: 10px"
      highlight-current-row
      @current-change="handleCurrentChangeColor"
    >
      <el-table-column prop="id" label="序号" width="160px" />
      <el-table-column prop="contactsNumber" label="分配人数" />
      <el-table-column prop="payUserNumber" label="支付人数" />
      <el-table-column prop="payNumber" label="支付次数" />
      <el-table-column prop="paySuccess" label="支付成功次数" />
      <el-table-column prop="payAmount" label="支付金额" />
      <el-table-column prop="linkName" label="客服名称" />
      <el-table-column
        prop="created"
        label="日期"
        width="160px"
      />
    </el-table>
    <div class="blank" />
    <!-- 分页 -->
    <el-pagination
      background
      :current-page="queryData.pageNo"
      :page-sizes="[15, 30, 50, 100, 200, total]"
      :page-size="queryData.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    />
  </div>
</template>

<script>
import { get, post } from '@/utils/request'
const moment = require('moment')
moment.locale('zh-cn')

export default {
  name: 'SystemCustomers2',
  components: {
  },
  data() {
    return {
      total: 0,
      queryData: {
        pageSize: 15,
        pageNo: 1,
        startTime: '',
        endTime: '',
        linkName: ''
      },
      created: '',
      married: '',
      date: '',
      tableData: [],
      currentRow: null
    }
  },
  created() {
    this.getList()

    this.showSum = false
    this.$nextTick().then(() => {
      this.showSum = true
    })
  },
  methods: {
    clear() {
      this.getList()
    },
    handleCurrentChangeColor(val) {
      this.currentRow = val
    },
    edit(index, row) {
      this.$router.push({
        path: 'stystem_edit',
        query: {
          id: this.tableData[index].id
        }
      })
    },
    handleSizeChange(val) {
      this.queryData.pageSize = val
      this.getList()
    },
    handleCurrentChange(val) {
      this.queryData.pageNo = val
      this.getList()
    },
    search() {
      if (!this.date == false) {
        this.queryData.startTime = moment(this.date[0]).format('YYYY-MM-DD')
        this.queryData.endTime = moment(this.date[1]).format('YYYY-MM-DD')
      } else {
        this.queryData.startTime = ''
        this.queryData.endTime = ''
      }
      this.getList()
    },
    getList() {
      get('/admin/baseService/v1/statistics', this.queryData).then((res) => {
        this.total = res.data.total
        this.tableData = res.data.list
      })
    }
  }
}
</script>
